// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2E2yC","sendOtp":"AuthorizeToLogin_sendOtp__10i7k"};